import React from 'react';
import { Link } from 'react-router-dom';
import { isEmbeddedOdysseyApp } from '../../services/appEnvironment';
import { useNativePurchases } from '../../services/nativePurchases';

export default function WebPurchaseRoute({ children }) {
  const purchases = useNativePurchases();
  if (!isEmbeddedOdysseyApp()) return children;
  return (
    <section className="card-os" style={{ maxWidth: 640, margin: '2rem auto', padding: 24 }}>
      <h1>Continue planning in OdysseyAI</h1>
      <p>{purchases.available ? 'Buy a one-time pack of 100 planning credits securely with Apple. No subscription or automatic renewal.'
        : 'Update OdysseyAI to purchase planning credits with Apple. Your saved trips remain available.'}</p>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 12 }}>
        {purchases.available && <button type="button" className="btn-os btn-os--primary" onClick={purchases.open}>Buy planning credits with Apple</button>}
        <Link to="/chat?mode=mobile" className="btn-os btn-os--secondary">Return to planner</Link>
      </div>
    </section>
  );
}
